(function () {

  console.log('[select-size] script loaded');

  const SELECT_TEXT = 'Select size';
  const ADD_TEXT = 'Add to cart';

  function setButtonState(form, disabled, labelText) {
    const message = document.querySelector(".size-selection-callout") 

    // Handle regular ATC button
    const btn = form.querySelector('[data-atc]');
    const label = form.querySelector('[data-atc-text]');
    
    if (btn && label) {
      btn.toggleAttribute('disabled', !!disabled);
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      label.textContent = labelText;
      message.innerText = "Please select a size"
    }

    // Handle preorder button
    const preorderBtn = form.querySelector('[data-essential-preorder-element="button"]');
    
    if (preorderBtn) {
      console.log('PREORDER FOUND')
      preorderBtn.toggleAttribute('disabled', !!disabled);
      preorderBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      
      // Update preorder button text (look for common text containers)
      const preorderLabel = preorderBtn.querySelector('span, [class*="text"]') || preorderBtn;

      if (preorderLabel && disabled) {
        console.log("Label is:" +preorderLabel)
        // Store original text if not already stored
        if (!preorderBtn.dataset.originalText) {
          preorderBtn.dataset.originalText = preorderLabel.textContent;
        }
        preorderLabel.textContent = labelText;
        message.innerText = "Please select a size"
      } else if (preorderLabel && !disabled && preorderBtn.dataset.originalText) {
        // Restore original preorder button text when enabled
        preorderLabel.textContent = preorderBtn.dataset.originalText;
      }
    }

    // // If this is a preorder button and it's disabled, force the text to stay as labelText
    // if (preorderBtn && disabled) {
    //   console.log('PREORDER & DISABLED HERE')
    //   // Clear any existing observer
    //   if (preorderBtn._textObserver) {
    //     preorderBtn._textObserver.disconnect();
    //   }

    //   // Watch for the preorder app changing the text back
    //   preorderBtn._textObserver = new MutationObserver(() => {
    //     if (label.textContent !== labelText) {
    //       label.textContent = labelText;
    //     }
    //   });

    //   preorderBtn._textObserver.observe(label, {
    //     characterData: true,
    //     childList: true,
    //     subtree: true
    //   });
    // } else if (preorderBtn._textObserver) {
    //   // Clean up observer when enabled
    //   preorderBtn._textObserver.disconnect();
    //   preorderBtn._textObserver = null;
    // }

  }

  function clearDefaultSelections(scopeEl, formId) {
    // radios tied to this form (even if they live elsewhere)
    const radioSelector = [
      `input[type="radio"][form="${formId}"][data-option-value-id]`,
      `input[type="radio"][form="${formId}"]`
    ].join(',');

    const radios = document.querySelectorAll(radioSelector);

    radios.forEach(r => {
      if (r.hasAttribute('checked')) {
        r.removeAttribute('checked');
      }
      r.checked = false;
      r.defaultChecked = false;
    });

    // selects tied to this form
    const selectSelector = [
      `select[form="${formId}"][name]`,
      `select[form="${formId}"][data-option-name]`
    ].join(',');

    const selects = document.querySelectorAll(selectSelector);
    selects.forEach(sel => {
      if (sel.options && sel.options.length) sel.selectedIndex = 0;
    });

    // hidden variant id inside the form
    const idInput = scopeEl.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      idInput.value = '';
    }

    // tell Dawn: no variant yet
    const section = scopeEl.closest('[data-section-id]');
    if (section) {
      section.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: null } }));
    }
  }

  function initializeForms() {
    const forms = document.querySelectorAll('product-form[data-requires-selection]');

    forms.forEach((pf) => {
      if (pf.dataset.sizeInit === '1') return;
      pf.dataset.sizeInit = '1';

      const form = pf.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (hasURLPreselectedVariant()) return; // respect ?variant=

      const formId = form.getAttribute('id');
      if (!formId) {
        console.warn('[select-size] form has no id, cannot target external inputs');
        return;
      }

      const doClear = () => {
        clearDefaultSelections(pf, formId);
        document.body.classList.add('js-ready');
        setButtonState(form, true, 'Select size');
      };

      // run now and a few retries to beat theme hydration
      requestAnimationFrame(doClear);
      setTimeout(doClear, 100);
      setTimeout(doClear, 300);
      setTimeout(doClear, 800);
    });
  }

  function hasURLPreselectedVariant() {
    const params = new URLSearchParams(window.location.search);
    return params.has('variant') && params.get('variant').trim() !== '';
  }

  function onVariantChange(e) {
    // Dawn dispatches 'variant:change' with detail.variant on the section/container
    const variant = e?.detail?.variant || null;
    const section = e.currentTarget;
    const pf = section.querySelector('product-form[data-requires-selection]');
    if (!pf) return;

    const form = pf.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('input[name="id"]');

    if (!variant) {
      if (idInput) idInput.value = '';
      setButtonState(form, true, SELECT_TEXT);
      return;
    }

    if (variant.available) {
      if (idInput) idInput.value = variant.id;
      setButtonState(form, false, ADD_TEXT);
    } else {
      if (idInput) idInput.value = variant.id; // keep id for pickup widget, etc.
      setButtonState(form, true, 'Sold out');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeForms();
    // Listen per product section for Dawn's native event
    document.querySelectorAll('[data-section-id]').forEach(section => {
      section.addEventListener('variant:change', onVariantChange);
    });
  });
})();